import { ArrowLeft } from 'lucide-react'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { scrollToTop } from '../../lib/utils'

function CommingSoon() {
    const navigate = useNavigate()
    const { t } = useTranslation()

    useEffect(() => {
        scrollToTop()
    }, [])

    return (
        <div>
            <header style={{
                backgroundImage: `url("/assets/bg_meteo.png")`
            }} className='  bg-cover bg-center bg-no-repeat w-full h-[70vh]'>
                <div className='  w-full  px-8 py-1 h-full bg-gradient-to-r from-black/80 to-black-500/0'>
                    <p onClick={() => navigate("/")} className=' cursor-pointer flex mt-8 text-[15px] font-[400] flex-row text-white'>
                        <ArrowLeft size={20} className='mr-5' />
                        {t("back_to_home")}
                    </p>
                    <h1 className='text-[64px] mt-5 font-sans text-white font-bold' >{t("meteo_title")}</h1>
                    <div className='md:w-[60%]'>
                        <p className='text-white mt-3 text-[15px] '>{t("meteo_description")}</p>
                    </div>


                </div>
            </header>

            <section className='bg-white w-full py-5 px-10'>
                <div className='w-full h-[50vh] md:h-[70vh] flex flex-col md:flex-row'>
                    <div className=' relative w-[100%] md:w-[50%]'>
                        <h1 className='text-[32px] font-bold font-sans'>{t("fonction_prevu")}</h1>
                        <div>
                            <p className='mt-5 text-[18px] font-[400]'>📅 {t("fonction1_meteo")}</p>
                            <p className='mt-5 text-[18px] font-[400]'>🚨 {t("fonction2_meteo")}</p>
                            <p className='mt-5 text-[18px] font-[400]'>🛰️ {t("fonction3_meteo")}</p>
                            <p className='mt-5 text-[18px] font-[400]'>🌡️ {t("fonction4_meteo")}</p>
                            <p className='mt-5 text-[18px] font-[400]'>📱 {t("fonction5_meteo")}</p>
                        </div>
                        <img className='absolute -bottom-9 md:bottom-12 left-32' src="/assets/nuage.png" alt="" />
                    </div>
                    <div className=' relative w-[50%] h-[100%] justify-center hidden md:flex md:flex-row'>
                        <div className='h-[100%] w-[50%] flex items-center '>
                            <img className='w-[157px] h-[157px]' src="/assets/mobile.png" alt="mobile" />
                        </div>
                        <div className='flex flex-col w-[50%] items-start justify-between'>
                            <img className='w-[150px] h-[150px]' src="/assets/donne_meteo.png" alt="donne_meteo" />
                            <img className='w-[150px] h-[150px]' src="/assets/smart.png" alt="smart" />
                        </div>
                        <img className='absolute top-12 left-[100px]' src="/assets/goute.png" alt="" />
                        <img className='absolute top-4 left-[200px]' src="/assets/goutelette.png" alt="" />
                    </div>


                </div>
                <div className=' relative w-[100%]'>
                    <h1 className='text-[32px] font-bold font-sans'>{t("commncer_meteo")}</h1>
                    <ul className='list-disc pl-5 space-y-2'>
                        <li>{t("etape1_meteo")}</li>
                        <li>{t("etape2_meteo")}</li>
                        <li>{t("etape3_meteo")}</li>
                    </ul>
                    <img className='absolute top-4 right-[300px]' src="/assets/nuageux.png" alt="" />
                </div>
                <div className='w-full flex items-center mt-5'>
                    <button className='bg-[#15803D] cursor-not-allowed m-auto text-white px-8 py-2 rounded-md shadow-md animate-flash hover:animate-none'>
                        {t("biento")}...
                    </button>
                </div>

            </section>
        </div>
    )
}

export default CommingSoon